import React from 'react'
import { useSelector } from 'react-redux'
import { hooks as coreHooks, selectors as coreSelectors } from 'mage-core'
import { TitleSecondary } from '@klarna/bubble-ui'
import { Message } from 'mage-i18n'
import useUnresolvedDisputesCount from './hooks/useUnresolvedDisputesCount'
import useOrientation from './hooks/useOrientation'
import OrientationItems from './OrientationItems'
import useIsFeatureEnabled from '../../hooks/useIsFeatureEnabled'

function Orientation () {
  const tokenHelper = coreHooks.useTokenHelper()

  const isKlarnaRealm = useSelector(coreSelectors.isKlarnaRealm)

  const { data: pendingDisputes, isLoading: isLoadingDisputes } = useUnresolvedDisputesCount(
    tokenHelper
  )

  const orientationSlug =
    !isLoadingDisputes && pendingDisputes && pendingDisputes > 0
      ? 'merchant-orientation-v2-disputes'
      : 'merchant-orientation-v2'

  const { data: orientation, isLoading: isLoadingOrientation } = useOrientation(
    orientationSlug,
    tokenHelper
  )

  const isOrientationFeatureEnabled = useIsFeatureEnabled('meg.uhqm.orientation-v2')
  const isOrientationActive = isKlarnaRealm || isOrientationFeatureEnabled
  const isOrientationContentAvailable = orientation?.orientationItems.length > 0

  const showOrientation = isOrientationActive && isOrientationContentAvailable

  if (isLoadingDisputes || isLoadingOrientation || !showOrientation) {
    return null
  }

  return (
    <>
      <TitleSecondary>
        <Message path='orientation.title' fallback='Learn how to ...' />
      </TitleSecondary>
      <OrientationItems items={orientation.orientationItems} />
    </>
  )
}

export default Orientation
